// initilaize Language, FullSrc and Domain name
var lang = document.documentElement.lang;
var fullsrc = $(location).attr('href');
var domain = $(location).attr('hostname');
// --------------------------------------------------------------------------------
// Rtl Scripts Important
var _rtl = false;

// Validation Rules
var emailReg = /^([\w\-\.]{2,}\@[a-zA-Z-0-9]{2,}\.[\w\-]{2,4})/;
var numReg = /[0-9]/;
// ------------------------------------------------------------------
var trans = {
    _choiceCountyCode: 'الرجاء اختيار رمز البلد ',
    _errorEmailMsg: 'عنوان البريد الذي أدخلته غير صحيح!',
    _pleaseEnterNameMsg: 'الرجاء ادخال الاسم',
    _pleaseEnterEmailMsg: ' الرجاء ادخال البريد الاكتروني',
    _pleaseEnterMobileMsg: 'الرجاء ادخال رقم الهاتف',
    _pleaseEnterNumberOnly: 'رقم الهاتف يجب ان يكون ارقام فقط',
    _pleaseEnterValidMobileMsg: 'رقم الهاتف يجب أن يكون أكبر من 5 أرقام',
    _TooManyAttempts: 'عدد كبير جداً من الطلبات، يرجى المحاولة مرة أخرى بعد 30 ثانية',
    _errorSending: 'حدث خطأ ما , يرجى المحاولة لاحقا',
    _filesValidateType: ' يجب أن يكون ملفًا من نوع   doc, docx أو pdf,',
    _filesValidateSize: ' يجب أن يكون حجم الملفً أقل من 5 MB',
    _All: 'الكل',

}
if (lang === 'en') {
    trans = {
        _choiceCountyCode: 'Please Enter Country Code',
        _errorEmailMsg: 'Invalid Email',
        _pleaseEnterNameMsg: 'Please Enter Your Name',
        _pleaseEnterEmailMsg: 'Please Enter Your Email',
        _pleaseEnterMobileMsg: 'Please Enter Mobile Number',
        _pleaseEnterNumberOnly: 'Phone number must be numbers only',
        _pleaseEnterValidMobileMsg: 'Phone number must include more than 5 numbers',
        _TooManyAttempts: 'Too many attempts, please slow down the request.',
        _errorSending: 'There was an error while sending the message, Please try again later.',
        _filesValidateType: 'The files must be a file of type:  doc, docx or pdf.',
        _filesValidateSize: 'File size must be less than 5 MB',
        _All: 'All',
    }
} else if (lang === 'fr') {
    trans = {
        _choiceCountyCode: 'Veuillez choisir le code du pays',
        _errorEmailMsg: 'Mauvaise adresse email à l\'inscription',
        _pleaseEnterNameMsg: 'S\'il vous plaît entrez votre nom',
        _pleaseEnterEmailMsg: ' S\'il vous plaît entrez votre adresse email',
        _pleaseEnterMobileMsg: 'S\'il vous plaît entrez votre numéro de téléphone',
        _pleaseEnterNumberOnly: 'Le numéro de téléphone doit être composé uniquement de chiffres',
        _pleaseEnterValidMobileMsg: 'Le numéro de téléphone doit comporter plus de 5 chiffres.',
        _TooManyAttempts: 'Trop de demandes. Veuillez réessayer après 60 secondes.',
        _errorSending: 'Une erreur s\'est produite lors de l\'envoi du message. Veuillez réessayer ultérieurement.',
        _filesValidateType: 'Les fichiers doivent être d\'un type de fichier:  doc, docx ou pdf.',
        _filesValidateSize: 'La taille du fichier doit être inférieure à 5 Mo',
        _All: 'Voir tout',
    }
} else if (lang === 'tr') {
    trans = {
        _choiceCountyCode: 'Lütfen Ülke Kodunu Girin.',
        _errorEmailMsg: 'Geçersiz e-posta.',
        _pleaseEnterNameMsg: 'Lütfen adınızı giriniz.',
        _pleaseEnterEmailMsg: 'Lütfen e-posta giriniz.',
        _pleaseEnterMobileMsg: 'Lütfen Cep Numarası Girin.',
        _pleaseEnterNumberOnly: 'Telefon numarası yalnızca numara olmalıdır.',
        _pleaseEnterValidMobileMsg: 'Telefon numarası 5\'ten fazla numara içermelidir.',
        _TooManyAttempts: 'Çok fazla deneme, lütfen isteği yavaşlatın.',
        _errorSending: 'Mesaj gönderilirken bir hata oluştu, lütfen daha sonra tekrar deneyin.',
        _filesValidateType: 'Dosyalar şu türden bir dosya olmalıdır: doc, docx veya pdf.',
        _filesValidateSize: 'Dosya boyutu 5 MB\'tan küçük olmalıdır.',
        _All: 'All',
    }
} else if (lang === 'fa') {
    trans = {
        _choiceCountyCode: "لطفا کد کشور را وارد کنید",
        _errorEmailMsg: "ایمیل نامعتبر",
        _pleaseEnterEmailMsg: 'لطفاً ایمیل خود را وارد کنید',
        _pleaseEnterNameMsg: "لطفاً نام خود را وارد کنید",
        _pleaseEnterMobileMsg: "لطفاً شماره موبایل خود را وارد کنید",
        _pleaseEnterNumberOnly: "شماره تلفن فقط باید رقم باشد",
        _pleaseEnterValidMobileMsg: "شماره تلفن باید بیش از ۵ رقم باشد",
        _TooManyAttempts: "تعداد درخواستها از حد مجاز گذشت.",
        _errorSending: "خطا در ارسال پیام ، لطفاً اندکی بعد دوباره امتحان کنید.",
        _filesValidateType: "این باید پرونده ای از نوع doc ، docx یا pdf باشد ",
        _filesValidateSize: "اندازه پرونده باید کمتر از 5 مگابایت باشد",
        _All: "جمیع",
    }
}

jQuery(document).ready(function ($) {
    "use strict";
    rtlDetection();

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $(".NumericOnly").keydown(function (event) {
        // Allow: backspace, delete, tab, escape, and enter
        if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
            // Allow: Ctrl+A
            (event.keyCode == 65 && event.ctrlKey === true) ||
            // Allow: home, end, left, right
            (event.keyCode >= 35 && event.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        } else {
            // Ensure that it is a number and stop the keypress
            if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                event.preventDefault();
            }
        }
    });
    // --------------------------------------------------------------------------------

    function stripHTML(dirtyString) {
        var container = document.createElement('div');
        var text = document.createTextNode(dirtyString);
        container.appendChild(text);
        return container.innerHTML; // innerHTML will be a xss safe string
    }

    function isNumberKey(evt) {
        var charCode = (evt.which) ? evt.which : event.keyCode
        if (charCode > 31 && (charCode < 48 || charCode > 57))
            return false;
        return true;
    }

    function rtlDetection() {
        if ($("body").css('direction') == 'rtl') {
            _rtl = true;
        }
    }
});